import { CashFlowChart, CreateCashFlow } from '../Utilis/Types/CashFlow';
import { IGetAllResponse, IGetOneResponse } from '../Utilis/Types/Generic';
import { ApiService } from './ApiService';

export class CashFlowService extends ApiService {
  static pathName = 'cash_flow';

  static getAllCashFlows(): Promise<IGetAllResponse<CashFlowChart>> {
    return this.get(`${this.pathName}`);
  }

  static createOne = (body: CreateCashFlow): Promise<IGetOneResponse<CashFlowChart>> => {
    return this.post(`${this.pathName}`,body);
  };

  static updateOne = (id:string): Promise<IGetOneResponse<CashFlowChart>> => {
    return this.get(`${this.pathName}/${id}`);
  };

  static deleteOne = (id:string) => {
    return this.delete(`${this.pathName}/${id}`);
  }; 
}
